import { useEffect } from 'react'

export function Logout() {
  useEffect(() => {
    localStorage.clear()
    sessionStorage.clear()
    document.location.reload()
  }, [])

  return <h1>See you soon!!</h1>
}
